import "../stylesheets/addProductForm.scss";
import { ReactComponent as CloseIcon } from "../assets/icons/close.svg";
import { ChangeEvent, FormEvent, useState } from "react";
import { addProduct, AddProductType, ProductType } from "../services/api";
import { useNotification } from "../contexts/NotificationContext";

// TYPES

type AddProductFormProps = {
	onClose: () => void;
	onProductAdded: (product: ProductType) => void;
	category: string;
	subcategory?: string;
};

// COMPONENT

function AddProductForm({
	onClose,
	onProductAdded,
	category,
	subcategory,
}: AddProductFormProps) {
	const { notify } = useNotification();
	// STATES
	const [visible, setVisible] = useState<boolean>(true);
	const [featured, setFeatured] = useState<boolean>(false);
	// HANDLES
	const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const data = new FormData(e.currentTarget);
		const name = data.get("name") as string;
		const price = data.get("price") as string;
		const ingredients = data.get("ingredients") as string;
		const newProduct: AddProductType = {
			name: name,
			price: Number.parseInt(price),
			categoryLabel: category,
			subcategoryLabel: subcategory,
			ingredients: ingredients.split(","),
			featured,
		};
		const response = await addProduct(newProduct);
		if (response != undefined) {
			onProductAdded(response);
			notify({
				type: "validation",
				title: "Produit Ajouté",
				subtitle: "",
			});
		} else {
			notify({
				type: "error",
				title: "Impossible d'Ajouter le Produit",
				subtitle: "",
			});
		}
	};
	return (
		<form className="add-product-form" onSubmit={(e) => handleSubmit(e)}>
			<div className="name-price">
				<input type="text" name="name" placeholder="name" />
				<input
					type="number"
					name="price"
					placeholder="10.00"
					step=".01"
				/>
			</div>
			<textarea name="ingredients" placeholder="ingredients..." />
			<div className="featured">
				<input
					type="checkbox"
					name="featured"
					id="featured"
					onChange={(e) => setFeatured(e.currentTarget.checked)}
				/>
				<label htmlFor="featured">featured</label>
			</div>
			<button type="submit">ajouter</button>
			<button
				className="close-form"
				onClick={(e) => {
					onClose();
				}}
			>
				<CloseIcon />
			</button>
		</form>
	);
}

export default AddProductForm;
function notify(arg0: { type: string; title: string; subtitle: string }) {
	throw new Error("Function not implemented.");
}
